<script>
    /* eslint-disable new-cap */
import Layout from '@layouts/primary'
import { wastetypeMethods } from '@state/helpers'
// import store from '@state/store'
import ListLoading from '../../components/loading'

export default {
  $_veeValidate: {
    validator: 'new',
  },
  page: {
    title: 'Collections',
    meta: [{name: 'description', content: 'Collections'}],
  },
  components: { Layout, ListLoading },
  data() {
    return {
      search: '',
      loadingData: true,
      headers: [
        {text: 'Name', value: 'name'},
        {text: 'Actions', value: 'name', sortable: false},
      ],
      wasteTypes: [],
      selectedTypeID: 1,
      addWasteType:false,
      removeWasteType:false,
      dateDialog: false,
      newWasteType: {
        name: null
      },
      dictionary: {
        attributes: {
          // email: 'E-mail Address',
          // custom attributes
        },
        custom: {
          // name: {
          //   required: () => 'Name can not be empty',
          //   max: 'The name field may not be greater than 10 characters',
          //   // custom messages
          // },
          select: {
            required: 'Select field is required',
          },
        }
      },
      addCollection: false,
    }
  },

  mounted() {
    this.$validator.localize('en', this.dictionary)
    this.getWasteTypes().then(response => {
      let obj = this.$store.state.wastetypes.objects
      // console.log(obj)
      for (let v in obj) {
        // Create a copy of the object to update it
        let formattedObj = {
          ...obj[v]
        }
        // console.log(formattedObj)
        this.wasteTypes.push(formattedObj)

        // console.log(this.wasteTypes)
      }
      this.loadingData=false
      // eslint-disable-next-line handle-callback-err
    }).catch(error => {
      this.loadingData=false
    })

  },
  methods: {
    ...wastetypeMethods,
    async submit() {
      await this.$validator.validateAll().then((response) => {
        // console.log(response)
        if(response){
          let newType=this.newWasteType
          this.createNewWasteType(newType)
        }
      })
    },
    async createNewWasteType(newType) {
      await this.createWasteType(newType).then(d => {
        this.addWasteType = !this.addWasteType
        location.reload()
      })
    },
    changeRoute(r) {
      this.$router.push(r)
    },
    deleteType(serviceTypeID){
      if(this.$store.getters['auth/getUserRole'] === 'Admin') {
        this.selectedTypeID = this.wasteTypes.indexOf(serviceTypeID)
        // console.log(this.selectedTypeID)
        this.removeWasteType = true
      }
    },
    update(updatedType){
      this.$validator.validateAll()
    },
    actuallyDeleteType(dusht){
      dusht = parseInt(dusht)
      this.deleteWasteType({ id: dusht }).then( d => {
        this.removeWasteType = false
        location.reload()
      })
    },
    getWasteTypeName(id){
      if(this.wasteTypes[id]){
        return this.wasteTypes[id].name;
      }else{
        return "";
      }

    }
  },
}
</script>

<template>
  <Layout>
    <VContainer>
      <div class="">
        <h2 :class="$style.routeHeader">
          Waste Types
        </h2>
        <ListLoading :display="loadingData" />
      </div>
      <VBtn
        v-if="!loadingData"
        slot="activator"
        :class="$style.addButton"
        color="blue"
        @click="addWasteType = !addWasteType"
      >
        + WASTE TYPE
      </VBtn>
      <VLayout style="width: 100%">

        <VFlex
          xs0
          sm12
        />
        <VFlex
          xs12
          md5
        >
          <VTextField
            v-if="!loadingData"
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          />
        </VFlex>
      </VLayout>

      <VDataTable
        v-if="!loadingData"
        :headers="headers"
        :items="wasteTypes"
        :search="search"
        rows-per-page-text=""
        :rows-per-page-items="[10]"
      >
        <template
          slot="items"
          slot-scope="props"
        >
          <td class="text-xs-left">
            {{ props.item.name }}
          </td>
          <td class="text-xs-left">

            <VIcon
              small
              @click="deleteType(props.item)"
            >
              delete
            </VIcon>
          </td>
        </template>
      </VDataTable>
    </VContainer>
    <!-- ADD Service Type MODAL -->
    <VLayout
      row
      justify-center
    >
      <VDialog
        v-model="addWasteType"
        persistent
        max-width="500px"
        scrollable
      >
        <VCard>
          <VCardText>
            <VContainer grid-list-md>
              <h2>New Waste Type</h2>
              <VLayout wrap>

                <VFlex xs12>
                  <VTextField
                    v-model="newWasteType.name"
                    v-validate="'required'"
                    :error-messages="errors.collect('name')"
                    data-vv-name="name"
                    label="Name"
                    required
                  />
                </VFlex>
                <VFlex
                  xs12
                  sm6
                  md6
                >
                  <VBtn
                    color="blue"
                    block
                    outline
                    @click.native="addWasteType = false"
                  >
                    Close
                  </VBtn>
                </VFlex>
                <VFlex
                  xs12
                  sm6
                  md6
                >
                  <VBtn
                    color="blue"
                    block
                    @click.native="submit()"
                  >
                    Save
                  </VBtn>
                </VFlex>
              </VLayout>
            </VContainer>
          </VCardText>
        </VCard>
      </VDialog>
    </VLayout>
    <!-- Edit Service Type MODAL -->

    <!-- Delete Type -->
    <VLayout
      row
      justify-center
    >
      <VDialog
        v-model="removeWasteType"
        persistent
        max-width="500px"
        scrollable
      >
        <VCard>
          <VCardText>
            <VContainer grid-list-md>
              <h2>Are you sure you want to delete Service Type: "{{ getWasteTypeName(selectedTypeID) }}"?</h2>
              <VLayout wrap>
                <VFlex
                  xs12
                  sm6
                  md6
                >
                  <VBtn
                    color="blue"
                    block
                    outline
                    @click.native="removeWasteType = !removeWasteType"
                  >
                    Close
                  </VBtn>
                </VFlex>
                <VFlex
                  xs12
                  sm6
                  md6
                >
                  <VBtn
                    color="orange"
                    block
                    @click.native="actuallyDeleteType(wasteTypes[selectedTypeID].id)"
                  >
                    DELETE
                  </VBtn>
                </VFlex>
              </VLayout>
            </VContainer>
          </VCardText>
        </VCard>
      </VDialog>
    </VLayout>
  </Layout>
</template>

<style lang="scss" module>
    @import '@design';

    .routeHeader {
        display: inline-block;
    }

    .addButton {
        display: inline-block;
        float: right;
    }
</style>
